<template lang="html">
<div class="row">
  <div class="col-12 col-md-8">
    <h3>Wählen Sie bitte Ihre Zahlungsart</h3>
    <ul class="payment-method-selection list-unstyled">
      <li
      v-for="(paymentMethod, key) in paymentMethods"
      v-bind:paymentMethods="paymentMethods"
      v-bind:class="{active: selectedMethod == key}"
      @click="selectPaymentMethod($event, key)">
        {{paymentMethod.title}}
      </li>
    </ul>
    <p>
      Hiermit ermächtige ich die Thomas-Morus-Akademie zur Abbuchung von meinem Bankkonto oder meiner Kreditkarte.    </p>
    <form :action="API_BASE_URL + '/checkout/confirm'" class="paymentWidgets" :data-brands="payFrameBrands"></form>
    <small><font-awesome-icon icon="lock" /> Ihre Daten werden verschlüsselt übertragen.</small>
    <br/>
    <br/>
    <br/>
  </div>
  <div class="col-12 col-md-4 text-right">

    <div class="text-center">
      <h5>Ihre Buchungsübersicht</h5>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 text-left">
        Teilnahmegebühr
      </div>
      <div class="col-12 col-md-6 text-right">
        <span v-if="customer.price">{{customer.price | stringifyNumber(',', 2)}} EUR</span>
      </div>
    </div>

    <div class="row" v-for="(participant, index) in participants">
      <div class="col-12 col-md-6 text-left">
        {{index+2}}. Teilnehmer
      </div>
      <div class="col-12 col-md-6 text-right">
        <span v-if="participant.price">{{participant.price | stringifyNumber(',', 2)}} EUR</span>
      </div>

    </div>

    <hr/> Summe: <b>{{calculateTotalPrice | stringifyNumber(',', 2)}} EUR</b><br/>

  </div>
</div>

</template>

<script>
import Vue from 'vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'VRPayPaymentForm',
  props: ['paymentMethods', 'customer', 'eventInfo', 'participants'],
  components: {FontAwesomeIcon},
  data () {
    return {
      selectedMethod: 'debit',
      API_BASE_URL: Vue.config.api.VUE_APP_BASE_URL
    }
  },
  computed: {
    payFrameBrands () {
      let methods = "";
      for(let item in this.paymentMethods) {
        methods += this.paymentMethods[item].brands.join(' ') + ' '
      }
      return methods
    },
    calculateTotalPrice() {


      let price = this.customer.price ? this.customer.price : 0
      for (let i = 0; i < this.participants.length; i++) {
        price += this.participants[i].price ? this.participants[i].price : 0
      }
      return price;

    }
  },
  mounted () {
    Vue.globalEventBus.$on('payframe-ready', () => {
      console.log(this)
      this.showActivePaymentForm();
    })
  },
  methods: {
    showActivePaymentForm() {
      var cards = document.getElementsByClassName("wpwl-container-card");
      var debits = document.getElementsByClassName("wpwl-container-directDebit");
      if(this.selectedMethod == 'debit') {
        if(cards.length > 0) cards[0].style.display = 'none';
        if(debits.length > 0) debits[0].style.display = 'block';
      }
      if(this.selectedMethod == 'creditcard') {
        if(debits.length > 0) debits[0].style.display = 'none';
        if(cards.length > 0) cards[0].style.display = 'block';
      }
    },
    selectPaymentMethod (event, methodKey) {
      this.selectedMethod = methodKey;
      this.showActivePaymentForm();
      this.$emit('on-change-method', this.selectedMethod)
    }
  }
}
</script>

<style lang="css">


  .wpwl-container {
    margin-top:30px;
  }

  .wpwl-form {
    margin:0px;
  }

  .payment-method-selection li {
    list-style: none;
    width: 52%;
    padding: 10px;
    border: 1px solid #DDD;
    border-bottom: 1px solid transparent;
    cursor: pointer;
  }

  .payment-method-selection li:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  .payment-method-selection li:last-child {
    border-bottom: 1px solid #DDD;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .payment-method-selection li.active:last-child {
    border-bottom: 1px solid green;
  }

  .payment-method-selection li.active {
    border-color: green;
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/VRPayPaymentForm.vue